import { SettingsMenu } from "./media-player.settings";
import { Video } from "./media-player.video";
import {
  MediaPlayerContextProvider,
  MediaPlayerRoot,
  useMediaPlayerContext,
} from "./media-player.provider";
import { Controls } from "./media-player.controls";
import { Overlay } from "./media-player.overlay";
import { PreviewVideo } from "./media-player.preview-video";
import { useOverlay, useProgress } from "./media-player.hooks";
import { PlayButton, PlayIcon } from "./media-player.icons";
import { AEOTranscript } from "./transcript/aeo-transcript";

export const MediaPlayer = {
  Context: MediaPlayerContextProvider,
  Root: MediaPlayerRoot,
  Video: Video,
  Controls: Controls,
  Overlay: Overlay,
  PreviewVideo: PreviewVideo,
  SettingsMenu: SettingsMenu,
  useContext: useMediaPlayerContext,
  useOverlay: useOverlay,
  useProgress: useProgress,
  PlayButton: PlayButton,
  PlayIcon: PlayIcon,
  /** Build-time AEO video tag: renders the hidden transcript + VideoObject JSON-LD from a Wistia id. */
  AEOTranscript: AEOTranscript,
};

export type { MediaPlayerContextType as MediaPlayerProps } from "./media-player.types";
export type { VideoProps as MediaPlayerVideoProps } from "./media-player.types";
export type { ControlsProps as MediaPlayerControlsProps } from "./media-player.types";
export type { SettingsLabels as MediaPlayerSettingsLabels } from "./media-player.types";
export type {
  TranscriptCue,
  AEOTranscriptProps as MediaPlayerAEOTranscriptProps,
} from "./transcript/transcript.types";
